export const DEFAULT_TIMESTAMPS_PERIOD = 180;
